import * as React from "react";
import { FormField } from "./FormField";

interface OwnProps {
    compact?: boolean;
    label?: string | null;
    isHtml?: boolean;
}

export const ReviewField: React.SFC<OwnProps> = (props) => {

    const content = props.isHtml
        ? <div dangerouslySetInnerHTML={{ __html: (props.children as string) }} />
        : props.children;

    return <FormField name="" label={props.label || ""} compact={props.compact}>
        {content}
    </FormField>;
};

export const ReviewFieldAsDefListItem: React.SFC<OwnProps> = (props) => {
    return <>
        <dt>{props.label}</dt>
        {props.isHtml
            ? <dd dangerouslySetInnerHTML={{ __html: (props.children as string) }} />
            : <dd>{props.children}</dd>}
    </>;
};



// WEBPACK FOOTER //
// ./src/components/editors/ReviewField.tsx